import {Injectable} from '@angular/core';
import {Action, State, StateContext, StateToken, Store} from '@ngxs/store';

import {QUERYABLE_STATE_MODEL_DEFAULTS, QueryableState, QueryableStateModel} from '../../../../common/state/queryable.state';
import {QueryBuilder} from "../../../../common/query/query.builder";
import {
  UpdateInventoryCodeActiveSiderSection,
} from "./inventory-code.actions";

const INVENTORY_CODE_STATE_TOKEN = new StateToken<InventoryCodeStateModel>('inventory_code');

export interface InventoryCodeStateModel extends QueryableStateModel<any> {

}

@State<InventoryCodeStateModel>({
  name: INVENTORY_CODE_STATE_TOKEN,
  defaults: {...QUERYABLE_STATE_MODEL_DEFAULTS},
})
@Injectable()
// @ts-ignore
export class InventoryCodeState extends QueryableState {
  constructor(
    public store: Store,
    public queryBuilder: QueryBuilder,
  ) {
    super(store, queryBuilder);
  }

  // @ts-ignore
  @Action(UpdateInventoryCodeActiveSiderSection)
  updateInventoryCodeActiveSiderSection(ctx: StateContext<any>, action: any): void {
    ctx.patchState({
      activeSiderSection: action.name || null
    })
  }
}
